var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookDefault = function SvgFacebookDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M32,16 C32,7.1634375 24.8365625,0 16,0 C7.1634375,0 0,7.1634375 0,16 C0,23.9860625 5.85096875,30.6053125 13.5,31.805625 L13.5,20.625 L9.4375,20.625 L9.4375,16 L13.5,16 L13.5,12.475 C13.5,8.465 15.8886875,6.25 19.5434375,6.25 C21.2939688,6.25 23.125,6.5625 23.125,6.5625 L23.125,10.5 L21.1074375,10.5 C19.1198438,10.5 18.5,11.7333437 18.5,12.9986562 L18.5,16 L22.9375,16 L22.228125,20.625 L18.5,20.625 L18.5,31.805625 C26.1490313,30.6053125 32,23.9860625 32,16"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FacebookDefault.8149d4a0.svg";
export { ForwardRef as ReactComponent };